<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-pencil mr-2" />Approval Emas
            </h5>
            <hr />
            <b-row align-v="center">
                <b-col md="4">
                    <b-form-group label="No. Faktur">
                        <b-input-group>
                            <b-input
                                id="input-no-faktur"
                                placeholder="Masukkan No. Faktur"
                                @keydown.enter="searchNoFaktur"
                                v-model="noFaktur"
                                maxlength="60"
                            />

                            <b-input-group-append>
                                <b-button
                                    id="search-button"
                                    variant="primary"
                                    @click="searchNoFaktur"
                                    :disabled="isSubmitting"
                                >
                                    <i class="fa fa-fw fa-search mr-2" />Cari
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <ModalApproval
            ref="modalApproval"
            :item="selectedItem"
            mode="approval"
            :no-faktur="noFaktur"
            :attr="attr"
            :source="selectedItem && selectedItem.box ? selectedItem.box.source : null"
            @submit-approval="onApproved"
            @findings="showFindingsModal"
        />

        <ModalBuatTemuan
            ref="modalBuatTemuan"
            :item="selectedItem"
            :type="selectedItem && selectedItem.box ? selectedItem.box.source : 'PEI'"
            @refresh-items="onFindingsCreated"
        />
    </div>
</template>

<script>
import ModalBuatTemuan from "./ModalBuatTemuan.vue";
import ModalApproval from "./ModalApproval.vue";

export default {
    components: {
        ModalBuatTemuan,
        ModalApproval
    },
    data() {
        return {
            isSubmitting: false,
            inventoryId: null,

            number: "",
            noFaktur: "",

            arrDuplicateImei: "",

            fields: [
                { key: "no_faktur", label: "No Faktur", sortable: true },
                { key: "barang", label: "Barang", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "delivery", label: "Pengiriman", sortable: true }
            ],

            selectedItem: null,
            attr: {
                purity_xrf_tolerance: 20,
                dry_weight_tolerance: 0.05
            }
        };
    },
    computed: {},
    methods: {
        showFindingsModal() {
            this.$bvModal.hide("m-approval");
            this.$nextTick(() => {
                this.$refs.modalBuatTemuan.$bvModal.show("m-buat-temuan");
            });
        },

        onFindingsCreated() {
            this.selectedItem = null;
            this.noFaktur = "";
            this.$bvModal.hide("m-approval");
        },

        searchNoFaktur() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;
            this.$axios
                .get("gold-deliveries/approval/search/" + this.noFaktur)
                .then(res => {
                    this.selectedItem = {
                        id: res.data.data.id || res.data.data,
                        no_faktur: res.data.data.no_faktur || this.noFaktur,
                        ...res.data.data
                    };
                    this.attr = res.data.data.attr;
                    this.inventoryId = this.selectedItem.id;
                    this.$nextTick(() => {
                        this.$refs.modalApproval.show();
                    });
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onApproved(payload) {
            this.$axios
                .post("gold-deliveries/approval/approve", payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "No.Faktur " + this.noFaktur + " berhasil diapprove!"
                    );
                    this.$refs.modalApproval.showBarcode(res.data.data);
                    this.noFaktur = "";
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.$refs.modalApproval.stopLoading();
                });
        },

        parseStatusVariant(status) {
            switch (status) {
                case 1:
                    return "warning";
                case 2:
                    return "success";
                case 5:
                    return "danger";
                default:
                    return "light";
            }
        },

        parseStatusName(status) {
            switch (status) {
                case 1:
                    return "PENDING";
                case 2:
                    return "APPROVED";
                case 5:
                    return "HILANG";
                default:
                    return "LAINNYA";
            }
        }
    }
};
</script>
